import {
  ButtonExt,
  CalloutExt,
  CodeBlockExt,
  ContactCardExt,
  CustomTaskListExt,
  EmbedContentBlockExt,
  EmbedContentExt,
  FilePreviewExt,
  PdfComponentExt,
  IframeExt,
  ImageExt,
  ResizeableFigureExt,
  SnippetBlockExt,
  TimelineExt,
  TimelineItemExt,
  ToggleListExt,
  ToggleListItemContentExt,
  ToggleListItemExt,
  VideoExt,
  VideoRecordExt,
  VimeoExt,
  YoutubeExt,
} from '@distribute/shared/tiptap/extensions';

import { mergeAttributes } from '@tiptap/core';

// CustomTaskList Extension
const PreviewCustomTaskList = CustomTaskListExt.extend({
  renderHTML({ HTMLAttributes }) {
    return [
      'div',
      mergeAttributes({ class: 'custom' }, HTMLAttributes),
      'Custom task list',
    ];
  },
});

// ContactCard Extension
const PreviewContactCard = ContactCardExt.extend({
  renderHTML({ HTMLAttributes }) {
    return [
      'div',
      mergeAttributes({ class: 'custom' }, HTMLAttributes),
      'Contact card',
    ];
  },
});

// SnippetBlock Extension
const PreviewSnippetBlock = SnippetBlockExt.extend({
  renderHTML({ HTMLAttributes }) {
    return [
      'div',
      mergeAttributes({ class: 'custom' }, HTMLAttributes),
      'Snippet block',
    ];
  },
});

// Callout Extension
const PreviewCallout = CalloutExt.extend({
  renderHTML({ HTMLAttributes }) {
    return [
      'div',
      mergeAttributes({ class: 'custom' }, HTMLAttributes),
      'Callout',
    ];
  },
});

// FilePreview Extension
const PreviewFilePreview = FilePreviewExt.extend({
  renderHTML({ HTMLAttributes }) {
    return [
      'div',
      mergeAttributes({ class: 'custom' }, HTMLAttributes),
      'File preview',
    ];
  },
});

// PdfComponent Extension
const PreviewPdfComponent = PdfComponentExt.extend({
  renderHTML({ HTMLAttributes }) {
    return [
      'div',
      mergeAttributes({ class: 'custom' }, HTMLAttributes),
      'Pdf component',
    ];
  },
});

// CustomImage Extension
const PreviewCustomImage = ImageExt.extend({
  renderHTML({ HTMLAttributes }) {
    return ['div', HTMLAttributes, 'Image'];
  },
});

// CustomVideo Extension
const PreviewCustomVideo = VideoExt.extend({
  renderHTML({ HTMLAttributes }) {
    return ['div', HTMLAttributes, 'Video'];
  },
});

// VideoRecord Extension
const PreviewVideoRecord = VideoRecordExt.extend({
  renderHTML({ HTMLAttributes }) {
    return ['div', HTMLAttributes, 'Video record'];
  },
});

// ResizeableFigure Extension
const PreviewResizeableFigure = ResizeableFigureExt.extend({
  renderHTML({ HTMLAttributes }) {
    return ['div', mergeAttributes({ class: 'custom' }, HTMLAttributes), 0];
  },
});

// Iframe Extension
const PreviewIframe = IframeExt.extend({
  renderHTML({ HTMLAttributes }) {
    return [
      'div',
      mergeAttributes({ class: 'custom' }, HTMLAttributes),
      'Iframe',
    ];
  },
});

// Youtube Extension
const PreviewYoutube = YoutubeExt.extend({
  renderHTML({ HTMLAttributes }) {
    return [
      'div',
      mergeAttributes({ class: 'custom' }, HTMLAttributes),
      'Youtube',
    ];
  },
});

// Vimeo Extension
const PreviewVimeo = VimeoExt.extend({
  renderHTML({ HTMLAttributes }) {
    return [
      'div',
      mergeAttributes({ class: 'custom' }, HTMLAttributes),
      'Vimeo',
    ];
  },
});

// Button Extension
const PreviewButton = ButtonExt.extend({
  renderHTML({ HTMLAttributes }) {
    return [
      'div',
      mergeAttributes({ class: 'custom' }, HTMLAttributes),
      'Button',
    ];
  },
});

// EmbedContentBlock Extension
const PreviewEmbedContentBlock = EmbedContentBlockExt.extend({
  renderHTML({ HTMLAttributes }) {
    return [
      'div',
      mergeAttributes({ class: 'custom' }, HTMLAttributes),
      'Embed content block',
    ];
  },
});

// EmbedContent Extension
const PreviewEmbedContent = EmbedContentExt.extend({
  renderHTML({ HTMLAttributes }) {
    return [
      'div',
      mergeAttributes({ class: 'custom' }, HTMLAttributes),
      'Embed content',
    ];
  },
});

// CodeBlock Extension
const PreviewCodeBlock = CodeBlockExt.extend({
  renderHTML({ HTMLAttributes }) {
    return [
      'div',
      mergeAttributes({ class: 'custom' }, HTMLAttributes),
      'Code block',
    ];
  },
});

// Timeline Extension
const PreviewTimeline = TimelineExt.extend({
  renderHTML({ HTMLAttributes }) {
    return [
      'div',
      mergeAttributes({ class: 'custom' }, HTMLAttributes),
      'Timeline',
    ];
  },
});

// TimelineItem Extension
const PreviewTimelineItem = TimelineItemExt.extend({
  renderHTML({ HTMLAttributes }) {
    return [
      'div',
      mergeAttributes({ class: 'custom' }, HTMLAttributes),
      'Timeline item',
    ];
  },
});

// ToggleList Extension
const PreviewToggleList = ToggleListExt.extend({
  renderHTML({ HTMLAttributes }) {
    return [
      'div',
      mergeAttributes({ class: 'custom' }, HTMLAttributes),
      'Toggle list',
    ];
  },
});

// ToggleListItem Extension
const PreviewToggleListItem = ToggleListItemExt.extend({
  renderHTML({ HTMLAttributes }) {
    return [
      'div',
      mergeAttributes({ class: 'custom' }, HTMLAttributes),
      'Toggle list item',
    ];
  },
});

// ToggleListItemContent Extension
const PreviewToggleListItemContent = ToggleListItemContentExt.extend({
  renderHTML({ HTMLAttributes }) {
    return [
      'div',
      mergeAttributes({ class: 'custom' }, HTMLAttributes),
      'Toggle list item content',
    ];
  },
});

export const previewExtensions = [
  PreviewCustomTaskList,
  PreviewContactCard,
  PreviewSnippetBlock,
  PreviewCallout,
  PreviewFilePreview,
  PreviewCustomImage,
  PreviewCustomVideo,
  PreviewVideoRecord,
  PreviewResizeableFigure,
  PreviewIframe,
  PreviewYoutube,
  PreviewVimeo,
  PreviewButton,
  PreviewEmbedContentBlock,
  PreviewEmbedContent,
  PreviewCodeBlock,
  PreviewTimeline,
  PreviewTimelineItem,
  PreviewToggleList,
  PreviewToggleListItem,
  PreviewToggleListItemContent,
  PreviewPdfComponent,
];

export const pageWithContentSuggestions = [
  {
    id: 'feedback',
    emodji: '🗣',
    name: 'Get feedback on your page',
    text: 'Get feedback on my page.',
  },
  {
    id: 'ideas',
    emodji: '✨',
    name: 'Spark ideas',
    text: 'I need some fresh ideas and inspiration for this content. Can you help me brainstorm and suggest creative approaches?',
  },
  {
    id: 'changes',
    emodji: '🖋️️',
    name: 'Suggest changes',
    text: `Can you help me make sure my writing is clear and easy to understand? I'd love suggestions and feedback. Thanks!`,
  },
  {
    id: 'flag',
    emodji: '🚩',
    name: 'Flag confusing parts',
    text: 'Flag confusing parts.',
  },
];

export const blankPageSuggestions = [
  {
    id: 'product-solution-overview',
    emodji: '🔎',
    name: 'Product/Solution Overview',
    text: 'Create a concise overview of our solution with clear headers, bullet points for key features, and a comparison table showing how we address customer pain points.',
  },
  {
    id: 'meeting-recap',
    emodji: '📅',
    name: 'Meeting recap',
    text: 'Summarize our recent meeting with [Customer] using clear sections for discussion points, decisions made, and a bulleted list of action items with owners and deadlines.',
  },
  {
    id: 'executive-summary',
    emodji: '📄',
    name: 'Executive summary',
    text: 'Develop a one-page summary with bold headers, concise bullet points, a strategic value table, and expected business outcomes visualization for [Customer].',
  },
  {
    id: 'customer-success-plan',
    emodji: '📋',
    name: 'Customer success plan',
    text: 'Outline a tailored success plan for [Customer] with milestone timeline, success metrics table, and implementation phases with clear headers for each section.',
  },
  {
    id: 'business-case',
    emodji: '💼',
    name: 'Business case',
    text: 'Build a compelling business case with executive summary, cost-benefit table, ROI calculation, and bullet points highlighting key financial benefits for [Customer].',
  },
  {
    id: 'mutual-action-plan',
    emodji: '📝',
    name: 'Mutual action plan',
    text: 'Create a collaborative plan with a responsibility matrix, timeline visualization, milestone table, and clearly defined success criteria for both teams.',
  },
];
